import { vec3 } from "gl-matrix";

export type LightArgs = {
  name: string;
  parent?: string;
  position?: vec3;
  colour?: [number, number, number];
  strength?: number;
  quadratic?: number;
  linear?: number;
  constant?: number;
  nearPlane?: number;
  farPlane?: number;
  shadow?: boolean;
}

class Light {
  name: string;
  position: vec3;
  colour: vec3;
  strength: number;
  quadratic: number;
  linear: number;
  constant: number;
  nearPlane: number;
  farPlane: number;
  shadow: boolean;
  parent?: string;

  constructor(object: LightArgs) {
    this.name = object.name;
    this.parent = object.parent;
    this.position = object.position ? object.position : vec3.create();
    this.colour = object.colour ? vec3.fromValues(
      object.colour[0],
      object.colour[1],
      object.colour[2]
    ) : vec3.fromValues(0.5, 0.5, 0.5);
    this.strength = object.strength ?? 20;
    this.quadratic = object.quadratic ?? 0.032;
    this.linear = object.linear ?? 0.09;
    this.constant = object.constant ?? 1;
    this.nearPlane = object.nearPlane ?? 0.1;
    this.farPlane = object.farPlane ?? 1000;
    this.shadow = object.shadow ?? false;
  }

  translate(translateVec: [number, number, number]) {
    vec3.add(
      this.position,
      this.position,
      vec3.fromValues(...translateVec)
    );
  }

  exportValues(): ExportedLight {
    return {
      name: this.name,
      colour: [this.colour[0], this.colour[1], this.colour[2]] as [number, number, number],
      position: [this.position[0], this.position[1], this.position[2]] as [number, number, number],
      strength: this.strength,
      quadratic: this.quadratic,
      linear: this.linear,
      constant: this.constant,
      nearPlane: this.nearPlane,
      farPlane: this.farPlane,
      parent: this.parent,
      shadow: this.shadow,
    };
  }
}

export type ExportedLight = {
  name: string;
  colour: [number, number, number];
  position: [number, number, number];
  strength: number;
  quadratic: number;
  linear: number;
  constant: number;
  nearPlane: number;
  farPlane: number;
  parent?: string;
  shadow: boolean;
};

export default Light;
